<template>
    <tr class="event-card">
        <td class="is--date">{{ event.starttime | moment("DD.MM.YYYY") }} - {{ event.endtime | moment("DD.MM.YYYY") }}</td>
        <td class="is--company" v-if="event.company.title">{{ event.company.title }}</td>
        <td class="is--address">{{ event.company.zip }} {{ event.company.city }}</td>
        <td class="is--homepage text-center">
            <a v-if="event.company.homepage" :href="('http' !== event.company.homepage.substr(0, 4) ? 'http://' : '') + event.company.homepage" target="_blank">{{ event.company.homepage }}</a>
            <template v-else>-</template>
        </td>
    </tr>
</template>

<script>
  export default {
    props: {
      event: Object
    },

    data() {
      return {};
    },
  }
</script>

<style lang="scss">
    @media (min-width: 786px) {
        td {
            &.is--date,
            &.is--homepage {
                width: 20%;
            }
            &.is--company,
            &.is--address {
                width: 30%;
            }
        }
    }
</style>
